import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { IConnectionDetailsDTO, IDeleteConnectionRequestParams } from '../../../../../../api/connections.dao';
import { ConnectionFormPresentation } from './connection-form.presentation';
import { ConnectionFormVM, MeetingApiParams } from './connection-form.viewmodel';
import { IOrganizationsForSpeakersSync } from './_sync-speakers/sync-speakers.viewmodel';
import { IDeleteConnectionDetails } from '../_connection-delete-confirm-popover';
import { ConnectionVersion } from '../../../../../../constants/common.constants';

interface IMeetingFormContainerProps {
    meetingApiParams: MeetingApiParams;
    meetingConnectionDetails: IConnectionDetailsDTO;
    executeSubmitApiCall: (connectionDetails: IConnectionDetailsDTO) => void;
    onCloseZoomConnection?: () => void;
    deleteConnection?: (data: IDeleteConnectionRequestParams, connectionDetails: IDeleteConnectionDetails) => Promise<void>;
    getKnovioConnectionDetails?: (connectionDetails: IConnectionDetailsDTO) => Promise<IConnectionDetailsDTO>;
    isMeetingConnectionsForm?: boolean;
    showZoomAutoRegAndAutoSyncToggles?: boolean;
    isClonedConnection?: boolean;
    shouldShowKnovioReplayToggle?: boolean;
    zoomMeetingType?: string;
    organizationsForSpeakersSync?: IOrganizationsForSpeakersSync;
    connectionVersion: ConnectionVersion;
}

const ConnectionFormContainer = withViewModel(ConnectionFormPresentation,
    (props: IMeetingFormContainerProps) => {
        const connectionFormVM = new ConnectionFormVM(
            props.connectionVersion,
            props.meetingConnectionDetails,
            props.meetingApiParams,
            props.executeSubmitApiCall,
            props.onCloseZoomConnection,
            props.deleteConnection,
            props.getKnovioConnectionDetails,
            props.isMeetingConnectionsForm,
            props.showZoomAutoRegAndAutoSyncToggles,
            props.isClonedConnection,
            props.shouldShowKnovioReplayToggle,
            props.zoomMeetingType,
            props.organizationsForSpeakersSync,
        );
        connectionFormVM.initialize();
        return connectionFormVM;
    },
    props => [props.meetingConnectionDetails],
);

export { ConnectionFormContainer as ConnectionForm };
